<template>
	<div class="wzry_content">
		<div class="wzry_form">
			<div class="utitle">
				CFer你好，
				<br />
				欢迎进入虚贝账号评估系统
			</div>
			<div class="form-input">
				<div class="finput" @click="toShow(jx_num, 1)">
					<span class="num">军衔</span>
					<span class="val">
						<em>{{ jx_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>
				<div class="finput" @click="toShow(yxjwq_num, 2)">
					<span class="num">英雄级武器数</span>
					<span class="val">
						<em>{{ yxjwq_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>

				<div class="finput" @click="toShow(wzjwq_num, 3)">
					<span class="num">王者级武器数</span>
					<span class="val">
						<em>{{ wzjwq_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>

				<div class="finput" @click="toShow(dj_num, 4)">
					<span class="num">命运/幻彩/梦幻级道具数...</span>
					<span class="val">
						<em>{{ dj_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>
			</div>
		</div>

		<div class="ftBtn">
			<router-link to="/" class="fh"><img src="/static/images/returnBtn.png" /></router-link>
			<div class="gz" @click="guzhi"><img src="/static/images/gzBtn.png" /></div>
		</div>

		<vue-pickers
			:show="show"
			:columns="columns"
			:defaultData="defaultData"
			:isRemember="true"
			:selectData="pickerData"
			@cancel="close"
			@confirm="confirmFn"
		></vue-pickers>
		<div class="mask" v-if="isMask"></div>
	</div>
</template>

<script>
import vuePickers from 'vue-pickers';
import { Toast } from 'mint-ui';
export default {
	name: 'home',
	components: { vuePickers, Toast },
	data: function () {
		return {
			id: this.$route.query.id,
			username: this.$route.query.username,
			isMask: false,
			show: false,
			type: 1,
			columns: 1,
			pickerData: {},
			defaultData: [],

			//军衔
			jx_defaultData: [{ text: '元帅及以下', value: '100' }],
			jx_num: {
				data1: [
					{ text: '元帅及以下', value: '100' },
					{ text: '大元帅', value: '200' },
					{ text: '告诫元帅', value: '500' },
					{ text: '元首', value: '1000' }
				]
			},

			//英雄级武器
			yxjwq_defaultData: [{ text: '0-10', value: '6216' }],
			yxjwq_num: {
				data1: [
					{ text: '0-10', value: '6216' },
					{ text: '11-40', value: '31080' },
					{ text: '41-100', value: '66600' },
					{ text: '101-300', value: '217560' },
					{ text: '300以上', value: '279720' }
				]
			},

			//王者级武器
			wzjwq_defaultData: [{ text: '0', value: '0' }],
			wzjwq_num: {
				data1: [
					{ text: '0', value: '0' },
					{ text: '1~4', value: '3600' },
					{ text: '5~8', value: '8400' },
					{ text: '9~12', value: '13200' },
					{ text: '12以上', value: '14400' }
				]
			},

			dj_defaultData: [{ text: '0', value: '0' }],
			dj_num: {
				data1: [
					{ text: '0', value: '0' },
					{ text: '1~5', value: '864' },
					{ text: '6~20', value: '5184' },
					{ text: '20~40', value: '10368' },
					{ text: '40以上', value: '12096' }
				]
			}
		};
	},
	mounted() {
		document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
			WeixinJSBridge.call('hideToolbar');
		});
	},
	methods: {
		toShow(data, type) {
			console.log(data);
			this.show = true;
			this.isMask = true;
			this.pickerData = data;
			this.type = type;

			if (type === 1) {
				this.defaultData = this.jx_defaultData;
			} else if (type === 2) {
				this.defaultData = this.yxjwq_defaultData;
			} else if (type === 3) {
				this.defaultData = this.wzjwq_defaultData;
			} else if (type === 4) {
				this.defaultData = this.dj_defaultData;
			}
		},
		close() {
			this.show = false;
			this.isMask = false;
		},
		confirmFn(val) {
			this.show = false;
			this.isMask = false;
			let type = this.type;
			if (type === 1) {
				this.jx_defaultData = [val.select1];
			} else if (type === 2) {
				this.yxjwq_defaultData = [val.select1];
			} else if (type === 3) {
				this.wzjwq_defaultData = [val.select1];
			} else if (type === 4) {
				this.dj_defaultData = [val.select1];
			}
		},
		guzhi() {
			var guzhi =
				Number(this.jx_defaultData[0].value) +
				Number(this.yxjwq_defaultData[0].value) +
				Number(this.wzjwq_defaultData[0].value) +
				Number(this.dj_defaultData[0].value);
			this.$router.push({ path: '/animation?id=4&username=' + this.username + '&amountValue=' + guzhi });
		}
	}
};

// 百度统计代码
var _hmt = _hmt || [];
(function () {
	var hm = document.createElement('script');
	hm.src = 'https://hm.baidu.com/hm.js?ad99db41be5b87499521b6c4980a6ec2';
	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(hm, s);
})();
</script>

<style lang="scss" scoped>
@function px2rem($px) {
	@return $px / 75;
}
.wzry_content {
	width: 10rem;
	margin: 0 auto;
	background: #221e27 url(/static/images/cyhx.jpg) no-repeat;
	background-size: 100% auto;
	.wzry_form {
		padding-top: px2rem(265rem);
		padding-bottom: px2rem(270rem);
		.utitle {
			color: #e9e8d1;
			font-size: px2rem(40rem);
			padding: 0 px2rem(70rem);
			margin-bottom: px2rem(64rem);
			letter-spacing: 1px;
			font-weight: bold;
			text-shadow: 1px 2px 3px #211d1d;
		}
		.form-input {
			text-align: center;
			.finput {
				width: px2rem(610rem);
				height: px2rem(90rem);
				line-height: px2rem(90rem);
				background: #363137;
				color: #ffddb5;
				border-radius: 5px;
				padding: 0 px2rem(15rem);
				margin: 0 auto;
				font-size: px2rem(30rem);
				position: relative;
				text-align: left;
				overflow: hidden;
				margin-bottom: px2rem(30rem);
				.num {
					color: #9c9580;
					float: left;
				}
				.val {
					color: #f2f1e0;
					float: right;
					em {
						font-style: normal;
						padding-right: px2rem(20rem);
					}
					img {
						width: px2rem(39rem);
						height: px2rem(23rem);
					}
				}
			}
		}
	}
	.ftBtn {
		display: flex;
		background: #000;
		padding: px2rem(20rem) 0;
		position: fixed;
		left: 0;
		bottom: 0;
		width: 100%;
		.fh {
			flex: 1;
			margin-left: px2rem(10rem);
			img {
				width: px2rem(252rem);
				height: px2rem(106rem);
			}
		}
		.gz {
			margin-right: px2rem(20rem);
			img {
				width: px2rem(436rem);
				height: px2rem(105rem);
			}
		}
	}

	.combox {
		width: px2rem(610rem);
		height: px2rem(130rem);
		margin: 0 auto;
		background: #34271f;
		margin-bottom: px2rem(40rem);
		border-radius: 5px;
		position: relative;
		.cn {
			color: #fff;
			padding: px2rem(25rem);
			font-size: px2rem(32rem);
		}
	}

	.combox:before {
		display: inline-block;
		width: 0;
		height: 0;
		border-width: px2rem(35rem);
		border-style: solid dashed dashed dashed;
		border-color: #34271f transparent transparent transparent;
		content: '';
		position: absolute;
		bottom: px2rem(-56rem);
		right: 50%;
		margin-left: px2rem(17.5rem);
	}

	.submitBtn {
		text-align: center;
		padding-top: px2rem(20rem);
		img {
			width: px2rem(616rem);
			height: px2rem(105rem);
		}
	}
	.copyRight {
		text-align: center;
		margin-top: px2rem(140rem);
		img {
			width: px2rem(419rem);
			height: px2rem(31rem);
		}
	}
}

.btnbox {
	display: flex;
	justify-content: center;
}
.btn {
	background: #2e68fa;
	color: #fff;
	padding: 5px 10px;
	display: inline-block;
	margin: 0 10px;
	font-size: 14px;
	border-radius: 4px;
}
.result {
	text-align: center;
	padding: 10px;
}
.isCopy {
	margin: 10px;
	border: 1px dashed red;
	text-align: center;
}

.wzry_content /deep/ .area_grid {
	border-top: 2px solid transparent;
	border-bottom: 2px solid transparent;
	-webkit-border-image: url(/static/images/dotted.jpg) 30 30 round;
	-o-border-image: url(/static/images/dotted.jpg) 30 30 round;
	border-image: url(/static/images/dotted.jpg) 30 30 round;
}

.wzry_content /deep/ .area_ctrl {
	font-size: 12px;
	vertical-align: middle;
	background-color: #413c3c;
	color: #fff;
	margin: 0;
	height: auto;
	width: 100%;
	position: fixed;
	width: 100%;
	left: 0;
	bottom: 0;
	z-index: 9901;
	overflow: hidden;
}

.wzry_content /deep/ .area_btn_box {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
	-webkit-box-align: stretch;
	-ms-flex-align: stretch;
	align-items: stretch;
	background-color: #393333;
	position: relative;
}

.wzry_content /deep/ .tooth {
	color: #fff;
	height: 2em;
	line-height: 2em;
	text-align: center;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	line-clamp: 1;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	overflow: hidden;
}

.wzry_content /deep/ .area_btn {
	color: #999;
	font-size: 1.6em;
	line-height: 1em;
	text-align: center;
	padding: 0.8em 1em;
}

.wzry_content /deep/ .larea_finish {
	color: #ffddb5;
}

.wzry_content /deep/ .area_btn_box:before,
.wzry_content /deep/ .area_btn_box:after {
	content: '';
	position: absolute;
	height: 1px;
	width: 100%;
	display: block;
	background-color: transparent;
	z-index: 15;
	-webkit-transform: scaleY(0.33);
	transform: scaleY(0.33);
}
.mask {
	width: 100%;
	height: 100%;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 999;
	background: #000;
	opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/pages/game/cyhx.vue